import Icon from '../../components/Icon.vue'

Icon.register({"regular/lemon":{"width":512,"height":512,"paths":[{"d":"M484.1 27.9C456-0.2 416.1-8.1 387.1 8.9 347.6 31.8 223.5-41.1 91.2 91.2-41.3 223.7 31.9 347.5 8.9 387.1-8.1 416.1-0.2 456 27.9 484.1 56 512.2 95.9 520 124.9 503.1 164.4 480.2 288.5 553.1 420.8 420.8 553.3 288.3 480.1 164.5 503.1 124.9 520.1 95.9 512.2 56 484.1 27.9zM461.7 100.8C422.9 167.4 507.3 266.4 386.9 386.9 266.4 507.3 167.4 422.9 100.8 461.7 78.1 474.9 36.8 434.5 50.3 411.2 89.1 344.6 4.7 245.6 125.1 125.1 245.6 4.7 344.6 89.1 411.2 50.3 433.9 37.1 475.2 77.6 461.7 100.8zM291.8 109.5C293.2 120.5 285.4 130.5 274.5 131.8 219.6 138.7 138.7 219.6 131.8 274.5 130.5 285.5 120.4 293.2 109.5 291.8 98.6 290.5 90.8 280.5 92.2 269.5 101.3 196.2 196.3 101.3 269.5 92.2 280.5 90.8 290.5 98.6 291.8 109.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/lemon.js
// module id = iiJS
// module chunks = 0